<script>
    import { formatMoney } from '$lib/utils/functions/money.js';

    import Picture from '$lib/components/Picture.svelte';

    export let product;
    export let showOutOfStock = true;
    export let showProductPrice = true;
    export let alignInfo = 'text-left';
    export let style = 'Framed';
    export let lazyLoadImage = true;

    // Style
    switch (style) {
        case 'None':
            style = '';
            break;
        case 'Framed':
            style = 'rounded-xl border border-base-900/5 bg-base-900 p-0 shadow-sm';
            break;
        default:
            style = 'rounded-xl border border-base-900/5 bg-base-900 p-0 shadow-sm';
            break;
    }

    let clubPromotion = product?.promotionClub?.value || undefined;
    let productPrice = product?.priceRange?.maxVariantPrice?.amount;
    let compareAtPrice = product?.compareAtPriceRange?.maxVariantPrice?.amount;
    let discountPercentage = Math.round(((compareAtPrice - productPrice) / compareAtPrice) * 100);
</script>

<a href="/products/{product?.handle}" title="{product?.vendor} {product?.title}">
    <div class="col-1 relative flex h-full flex-1 flex-col items-start justify-between overflow-hidden {style}">
        {#if !product?.availableForSale && showOutOfStock}
            <span class="absolute right-0 top-0 z-10 rounded-bl-xl bg-black/80 px-3 py-1 text-xs text-white">Out of Stock</span>
        {/if}
        <div class="flex aspect-square w-full place-items-center rounded-t-xl lg:px-2">
            <Picture
                src={product?.featuredImage?.url}
                alt="{product?.vendor} {product?.title}"
                width="250"
                height="250"
                imageSizes={[200, 250, 300]}
                classes={`m-auto w-full rounded-xl ${!product?.availableForSale && showOutOfStock ? 'opacity-50 grayscale' : ''}`}
                lazy={lazyLoadImage}
            />
        </div>
        <div class="p-4 pt-0 {alignInfo} w-full">
            <h3 class={`text-base font-medium ${!product?.availableForSale && showOutOfStock ? 'text-color-text' : 'dark:text-purple-300'}`}>
                {product?.title}
            </h3>
            <span class="block text-sm">By {product?.vendor}</span>
        </div>
        {#if showProductPrice}
            <div class="px-4 pb-4 {alignInfo} w-full">
                <span class="text-md font-semibold lg:text-lg">
                    {formatMoney(productPrice)}
                </span>
                {#if compareAtPrice && compareAtPrice > productPrice}
                    <span class="ml-1 inline-flex items-center gap-2 rounded-full bg-red-700 px-3 py-0.5 text-xs font-semibold text-white">
                        {discountPercentage}% OFF
                        <span class="hidden font-normal line-through md:inline-block">
                            {formatMoney(compareAtPrice)}
                        </span>
                    </span>
                {:else if clubPromotion}
                    <span class="ml-1 inline-flex items-center gap-2 rounded-full bg-base-700 px-3 py-0.5 text-xs font-semibold">
                        {clubPromotion}
                    </span>
                {/if}
            </div>
        {/if}
    </div>
</a>
